import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=2e2cc3b2"
import script from "./language-selector.vue?vue&type=script&lang=js"
export * from "./language-selector.vue?vue&type=script&lang=js"
import style0 from "./language-selector.vue?vue&type=style&index=0&id=2e2cc3b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports